module.exports = __webpack_public_path__ + "static/media/pratic-arquitet.3084cf0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/pratic-arquitet.png
// module id = 318
// module chunks = 0